<ng-container *ngIf="url; else noUrl">
    <div class="video-container">
        <iframe
            [src]="url | toHttps | safeResource"
            allowfullscreen
        ></iframe>
    </div>
</ng-container>

<ng-template #noUrl>
    <p>Video Url not provided</p>
</ng-template>
